/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { SocialShare } from "@quintype/components";
import { object, array, string, func } from "prop-types";
import { format } from "date-fns";

// import MetypeCommentWrapper from "../../metype-comments";
import StoryMetaInfo from "../../molecules/story-meta-info";
import CardImage from "../../atoms/card-image";
import Demarcation from "../../atoms/demarcation";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import StoryCard from "../story-card";
import StoryTag from "../story-tag";
import SideBar from "../side-bar";
import RelatedStories from "../related-stories";
import CardShareTemplate from "./card-share";
import ClockIcon from "../../atoms/icons/clock";
import KeyHighlights from "./ key-highlights";
import LightBox from "../../molecules/lightbox";
import DfpAd from "../../dfp-ad";

import { createImageElement, storyShareClickHandler } from "../../utils/";

import "./live-blog.m.css";

class LiveBlogStoryTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      renderMetype: false,
      showReadmore: {},
      wrapperClass: "",
      addReadmore: false,
      width: null,
      showPopup: false,
      element: null,
      getTime: "121"
    };
  }

  togglePopup = () => {
    this.setState({
      showPopup: !this.state.showPopup,
      element: this.state.showPopup ? null : createImageElement(this.props.story)
    });
  };

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();

    const cardId = this.props.cardId;
    if (cardId) {
      setTimeout(function() {
        document.getElementById(cardId) &&
          document.getElementById(cardId).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
      }, 10);
    }

    this.setState({
      renderMetype: true,
      cardsCount: this.props.story.cards.length,
      story: this.props.story,

      getTime: new Date()
        .getTime()
        .toString()
        .slice(-6)
    });

    const newScript = document.createElement('script');
    newScript.type = 'text/javascript';
    newScript.async = true;
    newScript.src = `https://tg1.playstream.media/api/adserver/spt?AV_TAGID=60782005312ec447057057b7&AV_PUBLISHERID=60781d1bde9e6c75091bfc17`;
    newScript.id = "AV60782005312ec447057057b7"
    document.body.appendChild(newScript);

    const mobileAdScript = document.createElement('script');
    mobileAdScript.type = 'text/javascript';
    mobileAdScript.async = true;
    mobileAdScript.src = "//sdk.adspruce.com/1/adspruce.js?pid=9656&sid=1";
    mobileAdScript.defer = true
    this.instance3.appendChild(mobileAdScript);

    this.storyUpdate = setInterval(this.updateStory.bind(this), 30000);
  }

  async updateStory() {
    const response = await window.fetch(`/api/v1/stories/${this.props.story.id}`);
    const jsonResponse = await response.json();
    this.setState({
      cardsCount: jsonResponse.story.cards.length,
      story: jsonResponse.story
    });
  }

  liveblogData(data) {
    return (
      data &&
      data.cards.map((card, index) => {
        return (
          <React.Fragment key={index}>
            {index !== 0 &&
              index % 3 === 0 && (
                <div styleName="dfp-ad2-728x90">
                  <DfpAd adtype="FPJ_ROS_Middle_1_728x90" />

                  {/* <Adsense adSlotId="5135370519" width="720" height="90" /> */}
                </div>
              )}
            <div styleName="story-cards" id={card.id} key={index}>
              <div styleName="show-time">
                <div styleName="published-time">
                  <span styleName="clock-icon">
                    <ClockIcon color="#ba0406" width={20} height={20} />
                  </span>
                  <time>{format(new Date(card["card-added-at"]), "d MMMM yyyy, hh:mm a")}</time>
                </div>
                <SocialShare
                  template={CardShareTemplate}
                  title={card.metadata["social-share"].title || data.headline}
                  url={data && data.slug + "?cardId=" + card.id}
                  color="#333"
                />
              </div>

              <StoryCard key={card.id} card={card} story={data} />
            </div>
          </React.Fragment>
        );
      })
    );
  }

  render() {
    const { story, trendingStories, collectionName, recentStories, config } = this.props;
    const { showPopup, element } = this.state;
    const publisherUrl = config["sketches-host"] || "https://www.freepressjournal.in";
    const colombiaAdStyle = {
      minHeight: "2px",
      width: "100%"
    };
    return (
      <React.Fragment>
        <div styleName="wrapper">
          <div>
            <StoryMetaInfo story={story} iconLiveBlog />
            <div styleName="card-image">
              {story["hero-image-s3-key"] && (
                <div onClick={this.togglePopup}>
                  <CardImage story={story} defaultWidth={760} aspectRatio={[16, 9]} imageType="image16x9" isStoryPage />
                </div>
              )}
            </div>
            <div styleName="image-attribute">
              {story["hero-image-caption"] && (
                <figcaption className="story-element-image-title">{story["hero-image-caption"]}</figcaption>
              )}
              {story["hero-image-attribution"] && (
                <figcaption className="story-element-image-attribution">{story["hero-image-attribution"]}</figcaption>
              )}
            </div>
            {this.state.width <= 992 && (
              <div styleName="dfp-ad-300x100">
                {/* <Adsense adSlotId="3689255812" width="300" height="250" /> */}
                <DfpAd adtype="FPJ_ROS_Mobile_Middle_300x250" />
              </div>
            )}
            {this.state.width > 992 && (
              <div styleName="dfp-ad2-728x90">
                {/* <Adsense adSlotId="5135370519" width="720" height="90" /> */}
                <DfpAd adtype="FPJ_ROS_Middle_728x90" />
              </div>
            )}
            <div styleName="story-content">
              <div>
                <SocialShare
                  template={StickySocialShareTemplate}
                  title={story.headline}
                  url={story.slug}
                  color="#000"
                  sticky
                  onClick={storyShareClickHandler(story["story-content-id"], `${publisherUrl}/${story.slug}`)}
                />
              </div>
              <div>
                  <div class="adspruce-bannerspot"></div>
                  <div ref={el => (this.instance3 = el)} />
                </div>
              <div>
                <div ref={divElement => (this.divElement = divElement)}>
                  <div styleName="content-wrapper">
                    {!this.state.cardsCount ? this.liveblogData(story) : this.liveblogData(this.state.story)}

                    {this.state.width > 992 && (
                      <div styleName="dfp-ad2-728x90">
                        {/* <Adsense adSlotId="5135370519" width="720" height="90" /> */}
                        <DfpAd adtype="FPJ_ROS_Middle_1_728x90" />
                      </div>
                    )}
                    {this.state.width <= 992 && (
                      <div styleName="dfp-ad-300x100">
                        <DfpAd adtype="FPJ_ROS_Mobile_Middle_1_300x250" />
                        {/* <Adsense adSlotId="5135370519" width="720" height="90" /> */}
                      </div>
                    )}
                    <StoryTag tags={story.tags} />
                    {/* {this.state.renderMetype && <MetypeCommentWrapper story={story} />} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {this.state.width >= 992 && (
              <div styleName="dfp-ad2-300x100">
                {/* <Adsense adSlotId="3689255812" width="300" height="250" /> */}
                <DfpAd adtype="FPJ_ROS_Middle_2_336x280" />
              </div>
            )}
            {!this.state.cardsCount ? <KeyHighlights story={story} /> : <KeyHighlights story={this.state.story} />}
            <SideBar stories={recentStories} collectionName={collectionName} id={story.id} liveBlog />
          </div>
        </div>

        {this.state.width > 768 && (
          <div
            id={story.id}
            style={colombiaAdStyle}
            data-slot="319925"
            data-position={this.state.getTime}
            data-section="0"
            data-ua="D"
            className="colombia"
          />
        )}
        {this.state.width <= 768 && (
          <div
            id={story.id}
            style={colombiaAdStyle}
            data-slot="319929"
            data-position={this.state.getTime}
            data-section="0"
            data-ua="M"
            className="colombia"
          />
        )}

        <div styleName="related-stories">
          <RelatedStories relatedStories={trendingStories} collectionName="trending" />
        </div>

        {showPopup ? <LightBox element={element} closePopup={() => this.togglePopup()} /> : null}
      </React.Fragment>
    );
  }
}

function LiveBlogStory(props) {
  return (
    <div className="story-grid">
      <LiveBlogStoryTemplate
        story={props.story}
        cardId={props.cardId}
        trendingStories={props.trendingStories}
        collectionName={props.collectionName}
        recentStories={props.recentStories}
        config={props.config}
      />
      <Demarcation />
    </div>
  );
}

LiveBlogStoryTemplate.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  cardId: string,
  recentStories: array,
  config: func
};

LiveBlogStory.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  recentStories: array,
  cardId: string,
  config: func
};

export default LiveBlogStory;
